import type { IGetEnglishIqSupplyV1Response } from '../getEnglishIqSupplyV1';
import { getEnglishIqSupplyV1ResponseSchema } from '../getEnglishIqSupplyV1';

export const publishEnglishIqSupplyV1ResponseSchema = getEnglishIqSupplyV1ResponseSchema;

export type IPublishEnglishIqSupplyV1Response = IGetEnglishIqSupplyV1Response;
